export default function LinkedList(length, mapper = (_, index) => index) {
  const array = Array.from({ length }, mapper).map((i) => ({
    index: i,
    left: null,
    right: null,
  }));

  const list = [];
  for (let i = 0; i < array.length; i++) {
    const lastIndex = array.length - 1;
    const prevIndex = i === 0 ? lastIndex : i - 1;
    const nextIndex = i === lastIndex ? 0 : i + 1;

    const current = array[i];
    const next = array[nextIndex];
    const prev = array[prevIndex];

    current.right = next;
    current.left = prev;

    list.push(current);
  }

  return list;
}
